// extracted by css-extract-rspack-plugin
export default {"table":"List__table--DRmo8","withHint":"List__withHint--ezZ5p","th":"List__th--h1LI5"};